import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ProductOverviewPage = lazy(
  () => import('~/features/onboarding/pages/product-overview-screen'),
);

export const Route = createFileRoute('/_authenticated/_tenant/onboarding/product-overview')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ProductOverviewPage />
    </Suspense>
  ),
});
